import { createReducer } from '@reduxjs/toolkit';
import { retrieveWhatsNewItemsResolved, fetchHTMLTextResolved, setIFrameUrl, updateWhatsNewState, } from '../actions';
export const initialState = {
    whatsNewItems: [],
    whatsNewHtml: '',
    iFrameUrl: '',
    lastWhatsNewVersionSeen: null,
    currentWhatsNewVersion: '',
    isLoading: true,
    whatsNewPageUrl: '',
    routeToReturnOnClose: undefined,
};
const reducer = {
    [retrieveWhatsNewItemsResolved.toString()]: (state, action) => ({
        ...state,
        whatsNewItems: [...action.payload],
    }),
    [fetchHTMLTextResolved.toString()]: (state, action) => ({
        ...state,
        whatsNewHtml: action.payload,
    }),
    [setIFrameUrl.toString()]: (state, action) => ({
        ...state,
        iFrameUrl: action.payload,
    }),
    [updateWhatsNewState.toString()]: (state, action) => ({
        ...state,
        ...action.payload,
    }),
};
export default createReducer(initialState, reducer);
